import { render, staticRenderFns } from "./DiagnosticsView.vue?vue&type=template&id=3b919300&scoped=true&"
import script from "./DiagnosticsView.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b919300",
  null
  
)

export default component.exports